import type React from "react"
import { ThemeProvider } from "@/components/theme-provider"
import { ScrollToTop } from "@/components/scroll-to-top"
import "./globals.css"

export default function RootLayout({
                                     children,
                                   }: {
  children: React.ReactNode
}) {
  return (
      <ThemeProvider defaultTheme="system">
          {/* <main> landmark fixes Lighthouse "landmark-one-main" */}
          <main id="main-content">
              {children}
          </main>
        <ScrollToTop />
      </ThemeProvider>
  )
}